import { format, isSameMonth, startOfQuarter } from 'date-fns';
export function getXAxisTextForQuarterlyDate(props) {
  const date = props.payload.value;
  return isSameMonth(startOfQuarter(date), date) ? format(date, 'MMM') : '';
}